import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import introImg from '../assets/newHeader/industry1.jpeg';
import image1 from '../assets/newHeader/industry5.jpeg';
import image2 from '../assets/newHeader/industry6.jpeg';
import image3 from '../assets/newHeader/industry7.jpeg';
import image31 from '../assets/newHeader/industry8.jpeg';
import image32 from '../assets/newHeader/industry9.png';
import buildRetail from '../assets/public-site/buildRetail.png';
import ellipseEducation from '../assets/public-site/ellipseEducation.png';
import { ReactComponent as CaptureIcon } from '../assets/public-site/empSystem.svg';
import hiringImage1 from '../assets/public-site/hiringImage1.png';
import connectingLine from '../assets/public-site/hiw-connectingLine.svg';
import { ReactComponent as TrackIcon } from '../assets/public-site/industry1.svg';
import retailLeader from '../assets/public-site/retailLeader.png';
import { ReactComponent as MatchIcon } from '../assets/public-site/svg16.svg';
import { FeatureCard } from '../components/common/FeatureCard';
// import { InfoCard } from '../components/common/InfoCard';
// eslint-disable-next-line import/order
import { ExportedIcon } from '../components/icons/icons';
import { NewFooter } from '../components/Layout/NewFooter';
import { NewNavbar } from '../components/Layout/NewHeader';

import { ConnectForm } from './ConnectUseForm';
export const IndustryPage: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const features = [
    {
      image: image1,
      title: 'Automate inefficient systems',
      description:
        'Skip the manual resume reviews and gut-feel interviews. Vero identifies top candidates based on skills, motivation, and performance signals—even for first-time retail workers.',
    },
    {
      image: image2,
      title: 'Predict success and reduce churn',
      description:
        'Match candidates to roles where they’ll thrive—before they walk through the door. In early pilots, our AI predicted job fit with up to 85% accuracy.',
    },
    {
      image: image3,
      title: 'Develop talent from day one',
      description:
        'Surface career growth opportunities, reduce regrettable churn, and support internal mobility by mapping each individual’s long-term potential.',
    },
    {
      image: image32,
      title: 'Build talent from day one',
      description:
        'Vero helps store leaders not just fill roles, but plan for growth—tracking readiness, surfacing internal mobility, and reducing re-training costs.',
    },
    {
      image: image31,
      title: 'Plug in, don’t rip out',
      description:
        'We work alongside your ATS, HRIS, and training systems—making your current stack smarter, not obsolete.',
    },
  ];

  return (
    <div>
      <NewNavbar />
      {/* container 1 */}
      <div className="relative w-full h-screen overflow-hidden">
        {/* Background image */}
        <img
          src={introImg}
          alt=""
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-30 z-10"></div>

        {/* Content at the bottom center */}
      </div>
      {/* Hiring Section */}
      <section className="py-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mt-12">
            {/* Left Content */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              {/* Left Column - Text */}
              <div className="text-center lg:text-left space-y-6">
                <div className="py-7">
                  <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light lg:!leading-[83px] mb-5">
                    Retail Hiring,{' '}
                    <span className="font-bold text-primary-500 block">Reinvented</span>
                  </h2>
                  <h3 className="text-black font-normal text-3xl md:leading-[54px] mb-4">
                    Match smarter. Reduce churn. Grow store-level talent with data.
                  </h3>
                  <p className="text-black font-normal text-xl leading-[36px]">
                    Vero helps retail teams automate hiring decisions, identify best-fit candidates,
                    and build workforce intelligence across every location. Whether you're managing
                    20 stores or 2,000, our AI pinpoints who to hire, where to place them, and how-
                    to retain them—faster and more accurately than traditional systems.
                  </p>
                </div>
              </div>
              <div className="flex justify-center lg:justify-start">
                <a
                  className="mt-6 btn btn-secondary !whitespace-normal !py-6 !px-8"
                  href="https://meetings.hubspot.com/chrissybil/vero-learning?uuid=6c88abd0-0695-4535-a0ea-e16922ce9f6d"
                  target="_blank"
                >
                  Schedule a strategy session <ExportedIcon />
                </a>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={hiringImage1}
                alt="Hiring Image"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
          </div>
        </div>
      </section>
      {/* Frontline Retail Section */}
      <section className="py-8 bg-green-200">
        <div className="container">
          <div className="text-center gap-6">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-normal leading-tight lg:!leading-[75px] mb-5">
              Frontline Retail Is
              <span className="font-bold text-primary-500"> Under Pressure</span>
            </h2>
            <div>
              <p className="text-xl text-center leading-[50px]">
                Turnover, absenteeism, and misplacement are eroding productivity and profits. Most
                systems weren’t built to predict who will succeed in dynamic, high-touch roles—or to
                help you grow talent from the ground up. Hiring managers are left guessing. Resumes
                are misleading. And reactive staffing leads to costly mistakes. Vero changes
                that—using predictive intelligence to make every decision smarter.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* What You Get Section */}
      <section className="py-16 bg-primary-200">
        <div className="mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-10">
            What You
            <span className="font-bold text-primary-500"> Get</span>
          </h2>
        </div>
        <div className="container">
          <div className="w-full flex justify-center">
            <div className="px-4 w-full space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6  place-items-stretch">
                {features.slice(0, 2).map((feature, index) => (
                  <FeatureCard
                    key={index}
                    image={feature.image}
                    title={feature.title}
                    description={feature.description}
                  />
                ))}
              </div>

              {/* Second row - 2 cards centered */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 place-items-center lg:justify-center">
                {features.slice(3).map((feature, index) => (
                  <FeatureCard
                    key={index + 3}
                    image={feature.image}
                    title={feature.title}
                    description={feature.description}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="px-5 pt-10 text-center lg:text-left">
            <h2 className="font-bold text-3xl leading-[54px] align-middle text-center lg:text-left mb-3">
              Want to see what your data could unlock?
            </h2>
            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning?uuid=285fbce6-aaf0-4c2a-8555-b242fc5b778d"
              className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal"
              target="_blank"
            >
              Book a walkthrough
              <ExportedIcon />
            </a>
          </div>
        </div>
      </section>
      {/* How It Works Section  */}
      <section className="pt-16">
        <div className="container">
          <div className="text-center mb-10">
            <h2 className="text-3xl sm:text-4xl md:text-6xl !leading-snug mb-6">
              How It
              <span className="text-primary-500 font-bold"> Works</span>
            </h2>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {/* Step 1 */}
            <div className="relative bg-primary-100 rounded-[40px] p-8 flex flex-col items-center text-center max-h-[450px]">
              <CaptureIcon className="mb-5" />
              <h3 className="text-2xl font-semibold mb-3">Capture Frontline Talent Signals</h3>
              <p className="text-lg ">
                Pull in skills, behavioral indicators, and readiness data to evaluate fit before the
                first interview.
              </p>
            </div>

            {/* Step 2 */}
            <div className="relative md:mt-[15%]">
              <img
                src={connectingLine}
                alt="connecting Line"
                className="relative -ml-10 hidden md:block"
              />
              <div className="bg-primary-100 rounded-[40px] p-8 flex flex-col items-center text-center max-h-[450px]">
                <MatchIcon className="mb-5" />
                <h3 className="text-2xl font-semibold mb-3">Match + Recommend</h3>
                <p className="text-lg ">
                  Our AI predicts who will perform, who will stay, and who can grow—with insights
                  tailored to your roles, stores, and team needs.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative md:mt-[50%]">
              <img
                src={connectingLine}
                alt="connecting Line"
                className="relative -ml-10  hidden md:block"
              />
              <div className="bg-primary-100 rounded-[40px] p-8 flex flex-col items-center text-center max-h-[450px]">
                <TrackIcon className="mb-5" />
                <h3 className="text-2xl font-semibold mb-3">Track, Learn, and Improve</h3>
                <p className="text-lg ">
                  Vero continuously learns from outcomes and manager feedback—refining every future
                  hire and reducing preventable churn.
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row items-center justify-between gap-4 py-10">
            <h2 className="font-bold text-2xl leading-[44px] align-middle text-center lg:text-left">
              Privacy-safe, API-friendly, and enterprise-ready—so your team can move fast, without
              risk.
            </h2>

            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal"
            >
              See store-level matching live
              <ExportedIcon />
            </a>
          </div>
        </div>
      </section>
      {/* Built for Retail Teams  Section */}
      <section className="pb-16">
        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-[35%_65%] gap-10 items-center mt-12">
            {/* Left Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={buildRetail}
                alt="build Retail"
                className="w-full 2xl:w-3/4 h-auto object-contain rounded-xl"
              />
            </div>
            {/* Right Content */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              {/* Right Column - Text */}
              <div className="mx-auto text-center lg:text-left">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5">
                  Built for Retail Teams That Can’t
                  <span className="font-bold text-primary-500"> Afford Guesswork</span>
                </h2>
              </div>
              <div className="text-center md:text-left space-y-6">
                {[
                  {
                    list: [
                      'Field HR teams managing multi-location hiring',
                      'District and store managers juggling volume and velocity',
                      'Retail organizations scaling frontline talent',
                    ],
                  },
                ].map((item, index) => (
                  <div key={index} className="mt-8">
                    {item.list && (
                      <ul className="text-black mt-4 text-xl list-disc list-outside font-normal leading-[40px] pl-5 text-left">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
              <div className="py-7">
                <p className="text-black font-normal text-xl leading-[40px] mb-6 text-center lg:text-left">
                  Whether you're hiring cashiers, stockers, or store managers—Vero helps you place
                  better bets, reduce churn, and retain your best people longer.
                </p>
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row items-center justify-between gap-4 py-10">
            <h2 className="font-bold text-3xl leading-[54px] align-middle text-center lg:text-left">
              Built for multi-site hiring - from flagship stores to remote locations.
            </h2>
            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal"
            >
              Book a strategy session
              <ExportedIcon />
            </a>
          </div>
        </div>
      </section>
      {/* Yellow Section */}
      <section className="py-8 bg-green-200">
        <div className="container">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div>
              <p className="text-2xl text-center lg:text-left">
                We specialize in frontline retail—not just HQ roles. Whether you're hiring cashiers,
                shift managers, or warehouse support, Vero helps you make decisions that stick.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Retail Leaders Section */}
      <section className="pt-16 pb-8 bg-primary-200 relative overflow-hidden">
        <div className="absolute top-[-4rem] lg:left-[-4rem]">
          <img src={ellipseEducation} alt="ellipse Educatione" className="object-contain" />
        </div>

        <div className="container px-4">
          <div className="grid grid-cols-1 lg:grid-cols-[40%_60%] gap-10 items-center">
            {/* Left Image */}
            <div className="relative w-full flex items-center justify-center">
              <img
                src={retailLeader}
                alt="Retail Image"
                className="w-full xl:w-4/4 h-auto object-contain rounded-xl"
              />
            </div>
            {/* Right Content */}
            <div className="mx-auto md:mt-10 items-center gap-10">
              {/* Right Column - Text */}
              <div className="text-center lg:text-left">
                <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light leading-tight lg:!leading-[75px] mb-5">
                  Why Retail Leaders
                  <span className="font-bold text-primary-500 block"> Choose Vero</span>
                </h2>
              </div>
              <div className="text-center md:text-left space-y-6">
                {[
                  {
                    desc: `Here’s what retail leaders are seeing in real time:`,
                    list: [
                      '85% accuracy in role prediction during pilot with Office Depot',
                      'Smart, store-specific candidate routing',
                      'Built to support multi-location, multi-role retail hiring',
                      'Predictive flags for absenteeism + no-shows',
                      'Profiles designed for onboarding, retention, and career growth—not just hire',
                    ],
                  },
                ].map((item, index) => (
                  <div key={index} className="mt-8">
                    <p className="text-black text-xl mb-10 text-center lg:text-left">{item.desc}</p>
                    {item.list && (
                      <ul className="text-black mt-4 text-xl list-disc list-outside font-normal leading-[40px] pl-5 text-left">
                        {item.list.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row items-center justify-between gap-4 py-10">
            <h2 className="font-bold text-3xl leading-[54px] align-middle text-center md:text-left">
              See Vero’s matching intelligence in action
            </h2>
            <a
              href="https://meetings.hubspot.com/chrissybil/vero-learning"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary !px-12 !py-6 hover:underline !whitespace-normal"
            >
              Schedule a 15-min demo
              <ExportedIcon />
            </a>
          </div>
        </div>
      </section>

      {/* container 13 */}
      <ConnectForm
        header="Make Every Hire Count"
        text="Ready to reduce churn, build better teams, and transform store-level performance? Built with frontline hiring in mind — from first interview to long-term growth. "
        buttonText="Book a conversation"
        actionButtonText="Start now"
      />
      <NewFooter />
    </div>
  );
};
